import React from 'react';
import { CTAButton } from './CTAButton';
export function SolutionSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-white py-3 md:py-4 px-3 relative border-b border-gray-200" data-id="element-165">
      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-166">
        <div className="inline-block bg-[#F5F0E6] border-2 border-[#D4A843] text-[#1F3D2B] font-black px-4 py-1 rounded-full mb-2 uppercase tracking-widest text-xs" data-id="element-167">
          💡 SOLUCIÓN
        </div>

        <h2 className="text-xl md:text-3xl font-black text-[#1F3D2B] mb-1 uppercase tracking-tight" data-id="element-168">
          🔥 KIT COMPLETO{' '}
          <span className="text-[#D4A843]" data-id="element-169">
            GESTIÓN AGROPECUARIA Y LEGISLACIÓN RURAL
          </span>
        </h2>

        <p className="text-sm md:text-base text-gray-600 font-bold mb-2 max-w-xl mx-auto" data-id="element-170">
          Un sistema completo para dejar de pensar tus clases y empezar a
          ejecutarlas.
        </p>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-1.5 max-w-2xl mx-auto mb-2 text-left" data-id="element-171">
          {[{
          text: '6 tomos (480 págs)',
          icon: '📚'
        }, {
          text: 'Contenido técnico para clase',
          icon: '✅'
        }, {
          text: 'Casos reales aplicados',
          icon: '📋'
        }, {
          text: 'Actividades y evaluaciones',
          icon: '📈'
        }, {
          text: 'Sistema estructurado',
          icon: '⚙️'
        }].map((item, i) => <div key={i} className="flex items-center gap-2 bg-[#F5F6F7] border border-gray-200 p-2 rounded-lg" data-id="element-172">
              <span className="text-lg flex-shrink-0" data-id="element-173">{item.icon}</span>
              <span className="text-[#1F3D2B] font-black text-xs md:text-sm" data-id="element-174">
                {item.text}
              </span>
            </div>)}
        </div>

        <div className="bg-[#1F3D2B] rounded-lg p-2 inline-block mb-3 w-full max-w-lg" data-id="element-175">
          <p className="text-[#D4A843] font-black text-sm md:text-base" data-id="element-176">
            👉 Todo organizado para que solo tengas que enseñar.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row justify-center gap-2 max-w-md mx-auto" data-id="element-177">
          <CTAButton onClick={scrollToPricing} variant="primary" className="px-4 py-3 text-sm w-full" data-id="element-178">
            VER OPCIONES DE COMPRA
          </CTAButton>
          <CTAButton onClick={scrollToPricing} variant="secondary" className="px-4 py-3 text-sm w-full" data-id="element-179">
            QUIERO DEJAR DE IMPROVISAR
          </CTAButton>
        </div>
      </div>
    </section>;
}